import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { urlFor, client } from "../../client";
import MotionWrap from "../../wrapper/MotionWrap";
import {images} from "../../constants/"

import "./Skills.scss";

const Skills = () => {
  const [experience, setExperience] = useState([]);
  const [skills, setSkills] = useState([]);
  const [skillsDesc, setSkillsDesc] = useState([]);

  useEffect(() => {
    const query = '*[_type == "experiences"]';
    const skillsQuery = '*[_type == "skills"]';
    const skillsDescQuery = '*[_type == "skillsDesc"]';

    client.fetch(query).then((data) => {
      setExperience(data);
    });

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });

    client.fetch(skillsDescQuery).then((data) => {
      setSkillsDesc(data);
    });
  }, []);

  const description = skillsDesc[0] || {};

  return (
    <div id="skills">
      <div className="left-content">
        <h1 className="title">
          PROS &<br />
          <span>BENEFICIALS</span>
        </h1>

        <div className="app__skills-container">
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="skill-desc"
          >
            <p>
              {description.skillsDesc}
            </p>
          </motion.div>
          <motion.div className="app__skills-list">
            {skills?.map((skill) => (
              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className="app__skills-item app__flex"
                key={skill.name}
              >
                <div
                  className="app__flex"
                  style={{ backgroundColor: skill.bgColor }}
                >
                  <img src={urlFor(skill.icon)} alt={skill.name} />
                </div>
                <p className="p-text">{skill.name}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
      <img id="benefitsImg" src={images.benefitsIllustration} alt="" />
    </div>
  );
};

export default MotionWrap(Skills, "app__skills");
